import { importLibrary, setOptions } from "@googlemaps/js-api-loader";

let configured = false;
let placesPromise: Promise<google.maps.PlacesLibrary> | null = null;

export function ensureGooglePlaces(): Promise<google.maps.PlacesLibrary> {
  if (!configured) {
    setOptions({
      key: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
      v: "weekly",
      region: "GB",
      language: "en-GB",
    });
    configured = true;
  }

  if (!placesPromise) {
    placesPromise = importLibrary("places") as Promise<google.maps.PlacesLibrary>;
  }

  return placesPromise;
}
